/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteExportedFilesRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {DeleteExportedFilesResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const deleteExportedFiles = (request:DeleteExportedFilesRequest, options?: CashRequestOptions) => post<DeleteExportedFilesRequest, DeleteExportedFilesResponse>("/2.0/cash/delete-exported-files", request, {...options, rejectOnError: true })